import axios from "axios";
import { BASE_URL } from "./api";


export async function uploadExpenseReceipt(token, expenseRecordId, file) {
    const formData = new FormData();
    formData.append('expense_record', expenseRecordId);
    formData.append('file', file);
    return axios({
        method: 'post',
        url: `${BASE_URL}/expense-receipts/`,
        headers: {
            'Authorization': `Token ${token}`,
            'Content-Type': 'multipart/form-data',
        },
        data: formData,
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        throw error;
    });
}


export async function deleteExpenseReceipt(token, id) {
    return axios({
        method: 'delete',
        url: `${BASE_URL}/expense-receipts/${id}/`,
        headers: {
            'Authorization': `Token ${token}`,
        },
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        throw error;
    });
}
